var _rect, _line, _polyline, _line2, _polyline2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorElevator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.042,
    y: 10.91,
    width: 21.916,
    height: 20.181,
    rx: 2.624,
    ry: 2.624
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.959,
    y1: 15.838,
    x2: 16.959,
    y2: 25.774
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "14.011 22.452 16.959 26.162 19.906 22.452"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.041,
    y1: 26.162,
    x2: 25.041,
    y2: 16.226
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "27.989 19.548 25.041 15.838 22.094 19.548"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18.549
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorElevator);
export default __webpack_public_path__ + "static/media/indoor-elevator.6d2e9e3dcda9beb3ef6e5c951744cfcb.svg";
export { ForwardRef as ReactComponent };